<div class="filter-bar-wrapper">
  <div class="filter-header">
    <h2>Topics</h2>
    <p *ngIf="isMobile" class="expand-filters" (click)="showAllFilters()">
      + View all topics
    </p>
  </div>

  <div class="filter-container" [class.show-all-filters]="expandFilters">
    <div
      class="filter"
      [class.selected]="
        this.selectedFilters.includes(+FilterBarEnum.allPostFilter)
      "
      (click)="onFilterChange([+FilterBarEnum.allPostFilter])"
    >
      <p>All Posts</p>
    </div>

    <ng-container *ngFor="let filter of filterItems; let i = index">
      <div
        class="filter"
        [class.selected]="this.selectedFilters.includes(+filter.filter_id)"
        (click)="onFilterChange([+filter.filter_id])"
      >
        <p>{{ filter.filter_label }}</p>
        <p
          class="deselect-cross"
          *ngIf="this.selectedFilters.includes(+filter.filter_id)"
        >
          X
        </p>
      </div>
    </ng-container>
  </div>
  <p *ngIf="!isMobile" class="expand-filters" (click)="showAllFilters()">
    + View all topics
  </p>
</div>
